import builder from '../builder';
import ChatTranslate from '../../streamline-icons/bold/chat-translate.svg';

export default builder('IconChatTranslateBold', ChatTranslate);
